import { isfunc } from './utils';
import { standardStrategy } from './strategies';
export function startLoadingPilets(options) {
    const state = {
        loaded: false,
        pilets: [],
        error: undefined,
    };
    const notifiers = [];
    const call = (notifier) => notifier(state.error, state.pilets, state.loaded);
    const notify = () => notifiers.forEach(call);
    const setPilets = (error, pilets) => {
        state.error = error;
        state.pilets = pilets;
        notify();
    };
    const setLoaded = () => {
        state.loaded = true;
        notify();
    };
    const { strategy = standardStrategy } = options;
    strategy(options, setPilets).then(setLoaded, setLoaded);
    return {
        connect(notifier) {
            if (isfunc(notifier)) {
                notifiers.push(notifier);
                call(notifier);
            }
        },
        disconnect(notifier) {
            const index = notifiers.indexOf(notifier);
            index !== -1 && notifiers.splice(index, 1);
        },
    };
}
//# sourceMappingURL=create.js.map